import React from 'react'

const Organizers = () => {
  return (
    <div>Organizers</div>
  )
}

export default Organizers